























import {Component, Vue} from "vue-property-decorator";
import {Action, Getter} from "vuex-class";
import Tickets from "@/components/MainWindow/Tickets.vue";
import Themes from "@/components/MainWindow/Themes.vue";
import Testing from "@/components/MainWindow/Testing.vue";
import Ticket from "./components/Ticket/Ticket";
import Theme from "./components/Theme/Theme";
import Loader from "./components/Loader.vue";
import Results from "./components/MainWindow/Results.vue";
import Result from "./components/Results/Result";
import ResultArray from "./components/Results/ResultArray";

@Component({
    components: {
        Results,
        Loader,
        Tickets,
        Themes,
        Testing,
    },
})
export default class App extends Vue {
    @Action("getTickets") private getTickets: any;
    @Action("getThemes") private getThemes: any;
    @Action("getExamQuestions") private getExamQuestions: any;
    @Action("getTicketQuestions") public getTicketQuestions: any;
    @Action("getThemeQuestions") public getThemeQuestions: any;
    @Action("getResults") public getResults: any;
    @Getter("results") public results!: ResultArray;

    public collapseMenuStatus: boolean = true;

    public tabs: string[] = ["Билеты", "Темы", "Экзамен"];

    public currentTab: string = this.tabs[0];

    public currentWindow: string = this.tabs[0];

    public title: string = "";

    public resultSelected: Result | null = null;

    private created() {
        this.currentTab = this.tabs[0];
        this.getTickets();
        this.getThemes();
        this.getResults();

        if (this.results.length > 0) {
            this.tabs.push("Результаты");
        }
    }

    collapseMenu(): void {
        this.collapseMenuStatus = !this.collapseMenuStatus;
    }

    public toResults(result: Result) {
        this.resultSelected = result;
        this.navSelect("Результаты");
    }

    public chooseWindow(tab: string, exam: boolean = false) {
        if (tab === this.tabs[2]) {
            this.$store.commit("startTest");
            this.currentWindow = "";

            setTimeout(() => {
                this.currentWindow = tab;
            }, 1000);

            if (exam) {
                this.getExamQuestions();
                this.$store.commit("startExam");
            } else {
                this.$store.commit("finishExam");
            }
        } else {
            this.$store.commit("finishTest");
            this.$store.commit("finishExam");
            this.currentWindow = tab;
        }

    }

    public navSelect(tab: string) {
        this.currentTab = tab;
        this.collapseMenuStatus = true;

        if (this.results.length > 0 && !this.tabs.includes("Результаты")) {
            this.tabs.push("Результаты");
        }

        if (tab === this.tabs[2]) {
            this.title = '';
            this.chooseWindow(tab, true);
        } else if (tab === this.tabs[3]) {
            this.chooseWindow(tab);
        } else {
            this.resultSelected = null;
            this.chooseWindow(tab);
        }
    }

    public ticketSelect(ticket: Ticket) {
        this.chooseWindow(this.tabs[2]);
        this.getTicketQuestions(ticket.id);
        this.title = ticket.title;
    }

    public themeSelect(theme: Theme) {
        this.chooseWindow(this.tabs[2]);
        this.getThemeQuestions(theme.id);
        this.title = theme.title;
    }

    public closeQuestions() {
        // this.currentWindow = this.tabs[0];
    }
}
